import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import { useCustomSelector } from 'hooks';
import React, { useState } from 'react';
import { useMainReportColumns } from '../hooks/useMainReportColumns';

import ic_update_db from "assets/images/ic_update_db.svg";

import "assets/scss/billingPortal/modules/reporting/creditNoteCommission.scss";
import { getTotalCountFromHeader, isArrayNotEmpty, isFunction, isObjectEmpty } from 'functions';
import { MultiFilters } from 'components/filters/MultiFilters';
import useReporting from 'dataflow/billingPortal/actions/useReporting.actions';
import useUpdateReportingData from '../../useUpdateReportingData';
import { SubmenuTooltip } from 'components/informational/SubmenuTooltip';
import { MoreButton } from 'components/buttons/MoreButton';

export default function MainReport({
    queries,
    setIsDrillDownReportVisible: setIsDrillDownReportVisible_props,
    setSelectedDealerDrillDown: setSelectedDealerDrillDown_props
}) {
    let setIsDrillDownReportVisible = isFunction(setIsDrillDownReportVisible_props)? setIsDrillDownReportVisible_props: () => {};
    let setSelectedDealerDrillDown = isFunction(setSelectedDealerDrillDown_props)? setSelectedDealerDrillDown_props: () => {};

    const [currentTabId, setCurrentTabId] = useState("newOutlet");

    let tabsDetails = [
        {
            id: "newOutlet",
            text: "New Outlet",
            filters: {
                level1: true
            }
        },
        {
            id: "recursive",
            text: "Recursive",
            filters: {
                level1: false
            }
        },
    ];

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");
    
    const {
        getCreditNoteCommissionList_requesting, creditNoteCommissionList,
        creditNoteCommissionListHeaders
    } = useCustomSelector("reporting");

    const { 
        getCreditNoteCommissionList = () => {}, 
    } = useReporting();
    
    const {
        columns
    } = useMainReportColumns(currentTabId);

    const {
        updateReportingDataModal,
        setIsModalVisible: setIsModalVisible_reportingData 
    } = useUpdateReportingData();

    return (
        <DashboardLayout
            headerTitle={"Dealer Commission Report"}

            bodyClassName={"credit-note-commission"}
            body={(
                <GeneralTable
                    className={"credit-note-commission__table"}
                    columns={columns}
                    data={userPermissions?.Internal_DealerReport_View? creditNoteCommissionList: []}

                    getTableData={(currentPage, pageSize, sort, filterOptions) => {
                        getCreditNoteCommissionList(currentPage, pageSize, sort, {
                            ...filterOptions,
                            agentType: "Dealer"
                        })
                    }}

                    onRowClick={(rowDetails) => {
                        let data = rowDetails?.original;

                        setIsDrillDownReportVisible(true);
                        setSelectedDealerDrillDown(data?.AgentCode);

                        queries.current = {
                            Year: data?.Year,
                            Month: data?.Month,
                            agent: data?.AgentCode,
                            level1: currentTabId === "newOutlet"
                        };
                    }}

                    outerTableHeader={(outerTableHeader_props) => {
                        const { 
                            filterOptions, setFilterOptions
                        } = outerTableHeader_props;

                        return (
                            <div className={"table__headers"}>
                                {/* Update Database Modal */}
                                {updateReportingDataModal}

                                {/* Top Section */}
                                <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                    {/* Title */}
                                    <div className={"headers__title tableHeaderTitle "}>
                                        Credit Note Commission
                                    </div>

                                    <SubmenuTooltip
                                        menuItems={[
                                            {
                                                icon: ic_update_db,
                                                label: "Update Database",
                                                isDisabled: !(userPermissions?.Internal_DealerReport_Add),
                                                onClick: () => setIsModalVisible_reportingData(true),
                                            }
                                        ]}
                                    >
                                        <MoreButton
                                            className={"action__more-actions"}
                                            iconClassName={"more-actions__icon"}
                                        />
                                    </SubmenuTooltip>
                                </div>

                                {/* Bottom Section */}
                                <div className={"headers__bottom-section"}>
                                    <MultiFilters
                                        defaultFilterOption={{
                                            label: "Dealer Code",
                                            propertyName: "agent",
                                            placeholder: "Dealer Code",
                                            inputType: "search",
                                        }}
                                        filterOptions={[
                                            {
                                                label: "Dealer Code",
                                                propertyName: "agent",
                                                placeholder: "Dealer Code",
                                                inputType: "search",
                                            },
                                            {
                                                label: "Date Range",
                                                propertyName_start: "dtFrom",
                                                propertyName_end: "dtTo",
                                                placeholder_start: "Start",
                                                placeholder_end: "End",
                                                inputType: "dateRange",
                                                isNotUsingMonthYear: true
                                            }
                                        ]}
                                        dropdownPlaceholder={"Select Filter"}
                                        onApplyFilter={(inputFilters) => {
                                            setFilterOptions(isObjectEmpty(inputFilters)? {}: { ...filterOptions, ...inputFilters});
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    }}

                    defaultFilter={{ level1: true }}
                    tabsDetails={tabsDetails}
                    onTabIdChange={(tabId) => {
                        setCurrentTabId(tabId);
                    }}
                    defaultTabId={currentTabId}
                    isTabRequired
                    
                    isTableDataLoading={getCreditNoteCommissionList_requesting}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(creditNoteCommissionListHeaders)}

                    isColumnResizeable
                    isTableOddRowsDarken
                />
            )}
        />
    );
}